module.exports = __webpack_public_path__ + "img/55.7c7fd514.jpg";